import { toast } from 'react-toastify';
import { deleteLocation } from './deleteLocation';

export const useDeleteLocationyData = () => {
  async function submitDeleteLocation(id: number) {
    const res = await deleteLocation(id);
    if (res.type === 'success') {
      toast.success('Successfully deleted location');
    } else {
      toast.error(res.error.message);
    }

    return res.type;
  }

  return { submitDeleteLocation };
};
